import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  tableViewScheduleStage,
  viewSchedule,
  viewStage,
} from '../../viewStage';

import { IViewStageState } from './IViewStageState';

const initialState: IViewStageState = {
  headerSwitchStage: 'schedule',
  scheduleViewStage: 'column',
  tableViewScheduleStage: 'byDay',
};

export const viewStageSlice = createSlice({
  name: 'viewStage',
  initialState: initialState,
  reducers: {
    setHeaderStage: (state, action: PayloadAction<viewStage>) => {
      state.headerSwitchStage = action.payload;
    },
    setViewScheduleStage: (state, action: PayloadAction<viewSchedule>) => {
      state.scheduleViewStage = action.payload;
    },
    setTableViewScheduleStage: (
      state,
      action: PayloadAction<tableViewScheduleStage>,
    ) => {
      state.tableViewScheduleStage = action.payload;
    },
  },
});

export const {
  setHeaderStage,
  setViewScheduleStage,
  setTableViewScheduleStage,
} = viewStageSlice.actions;
export const viewStageReducer = viewStageSlice.reducer;
